import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { schema, schemaDefaultValue } from "./schema";
import { useContext, useEffect, useState } from "react";
import LibMask from "../../../../util/mask";
import { ContextRegisterCollaborator } from "../context";
import { handleMessageError, handleMessageSuccess, handleMessageWarning } from "../../../toast";
import { ContextGlobal } from "../../../../context";
import LibBoolean from "../../../../util/libBool";
import reqColaborador from "../../../../services/reqMultiTenant/reqColaborador";
import reqTipoColaborador from "../../../../services/reqMultiTenant/reqTipoColaborador";
import { useAddress } from "../../../../hook/useAddress";
import reqPermissoes from "../../../../services/reqMultiTenant/reqPermissoes";

export const IndexHooks = () => {
	//#region variaveis de estado
	const { brazilStates, fetchCitiesByUf, loadingCities, listPermissionsData } = useContext(ContextGlobal);
	const {
		closeModalRegisterCollaborator,
		isOpenModalRegisterCollaborator,
		id_funcionario,
		setCollaboratorData,
		collaboratorData,
		loading,
		setLoading,
	} = useContext(ContextRegisterCollaborator);

	const [collaboratorTypeData, setCollaboratorTypeData] = useState([]);
	const [citiesData, setCitiesData] = useState([]);
	const [hasPermission, setHasPermission] = useState(false);

	const podeGerenciarPermissoes = Boolean(listPermissionsData?.cad_permissao);
	const editandoASiMesmo = id_funcionario > 0 && id_funcionario === listPermissionsData?.id_funcionario;
	//#endregion

	//#region Hook Form
	const {
		register,
		handleSubmit,
		setValue,
		setFocus,
		getValues,
		trigger,
		setError,
		reset,
		watch,
		control,
		formState: { errors, isSubmitting },
	} = useForm({
		mode: "all",
		reValidateMode: "onChange",
		resolver: zodResolver(schema),
		defaultValues: schemaDefaultValue,
	});
	//#endregion

	//#region Carregar dados do funcionario selecionado
	const fetchCollaborator = async () => {
		try {
			setValueTab("0");
			setLoading(true);
			setHasPermission(false);
			try {
				if (id_funcionario > 0) {
					const [responseCollaborator, responseCollaboratorType, responsePermissions] = await Promise.all([
						reqColaborador.listID(id_funcionario),
						reqTipoColaborador.listAll(),
						reqPermissoes.listIdPermission(id_funcionario),
					]);

					setCollaboratorTypeData(responseCollaboratorType.data);

					// Trata dados do colaborador
					if (
						typeof responseCollaborator.data === "object" &&
						responseCollaborator.data !== null &&
						!Array.isArray(responseCollaborator.data)
					) {
						const collaboratorData = responseCollaborator.data;

						const ativoValue = collaboratorData.ativo === "SIM";
						const pessoafisica = collaboratorData.pessoa_fisica === "SIM";

						collaboratorData.ativo = ativoValue;
						collaboratorData.pessoafisica = pessoafisica;

						if (collaboratorData.cep === null) collaboratorData.cep = "";

						Object.keys(collaboratorData).forEach((field) => {
							setValue(field, collaboratorData[field]);
						});
						await handleFetchCitiesByUf(collaboratorData.uf);
					}

					// Trata dados de permissões
					if (typeof responsePermissions.data === "object" && responsePermissions.data !== null) {
						const permissionsData = responsePermissions.data;

						// Atualiza os valores das permissões no formulário
						Object.keys(permissionsData).forEach((field) => {
							setValue(`permissoes.${field}`, permissionsData[field]);
						});

						setHasPermission(permissionsData.cad_permissao);
					}
				} else {
					const lUF = listPermissionsData?.uf || "SP";
					const lId_Cidade = listPermissionsData?.id_cidade;

					setValue("uf", lUF);
					setValue("id_cidade", lId_Cidade);

					await handleFetchCitiesByUf(lUF);

					reloadCollaboratorTypeData();
				}
			} catch (error) {
				handleMessageError(error.message);
				closeModalRegisterCollaborator();
			}
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (isOpenModalRegisterCollaborator === true) {
			fetchCollaborator();
		}
	}, [isOpenModalRegisterCollaborator]);
	//#endregion

	//#region Buscar Cidades pelo estado
	const handleFetchCitiesByUf = async (uf) => {
		try {
			const responseCities = await fetchCitiesByUf(uf); // Aqui vai a função para buscar as cidades

			setCitiesData(responseCities);
		} catch (error) {
			handleMessageWarning(error.message);
		}
	};
	//#endregion

	//#region Selecionar estado e buscar as cidades
	const handleSelectedState = async (selectedOption) => {
		// quando selecionar o estado no input chama essa função
		await handleFetchCitiesByUf(selectedOption.value);
		setValue("id_cidade", "");
	};
	//#endregion

	//#region Pesquisar e preenche o endereço pelo cep
	const { handleFetchAddressByCep, cepIsSubmitting } = useAddress(setValue, setFocus, getValues);

	const handleFetchAddress = async () => {
		try {
			const uf = await handleFetchAddressByCep();
			handleFetchCitiesByUf(uf);
		} catch (error) {
			handleMessageWarning(error.message);
		}
	};
	//#endregion

	//#region mascaras

	// const email = watch("email");

	const telefone_1 = watch("telefone_1");
	useEffect(() => {
		setValue("telefone_1", LibMask.phone(telefone_1));
		if (telefone_1?.length !== 14) return;
	}, [telefone_1, setValue]);

	const telefone_2 = watch("telefone_2");
	useEffect(() => {
		setValue("telefone_2", LibMask.phone(telefone_2));
		if (telefone_2?.length !== 14) return;
	}, [telefone_2, setValue]);

	//#endregion

	//#region Tipo Colaborador
	const handleCloseModal = () => {
		reset();
		closeModalRegisterCollaborator();
	};

	const insertCollaboratorType = async (data) => {
		try {
			const response = await reqTipoColaborador.insert(data);
			return response;
		} catch (error) {
			handleMessageError("Erro ao inserir Tipo de colaborador " + error);
		}
	};

	const reloadCollaboratorTypeData = async () => {
		try {
			const response = await reqTipoColaborador.listAll();

			setCollaboratorTypeData(response.data);
		} catch (error) {
			handleMessageError("Erro ao  atualizar Tipo de colaborador " + error.message);
		}
	};
	//#endregion

	//#region Tabs

	const [valueTab, setValueTab] = useState("0");

	const handleChangeTab = async (event, newValue) => {
		event.preventDefault();

		const isValid = await trigger();

		if (isValid) setValueTab(newValue);
	};
	//#endregion

	//#region Permission
	// #region onSubmit
	const handleOnSubmit = async (data) => {
		try {
			const newData = await ValidateSubmit(data);

			const responseCollaborator = await reqColaborador.insert(newData);

			const currentIdClient = responseCollaborator.data.id_funcionario;

			await reloadCollaboratorData(currentIdClient);

			handleMessageSuccess("Colaborador salvo com sucesso!");
		} catch (error) {
			if (error.field) errosAfterPost(error.field, error.message);

			handleMessageError("Erro ao salvar colaborador " + error.message);
		}
	};

	const ValidateSubmit = async (data) => {
		const newAtivo = LibBoolean.booleanToStr(data.ativo);
		const newPessoaFisica = LibBoolean.booleanToStr(data.pessoafisica);

		const newData = {
			...data,
			ativo: newAtivo,
			pessoafisica: newPessoaFisica,
		};

		return newData;
	};

	const reloadCollaboratorData = async (currentId) => {
		try {
			try {
				//lista o cliente no qual foi feita a inserção ou alteração
				const response = await reqColaborador.listID(currentId);
				//pego somente o primeiro pq neste caso mando sempre 1 resgistro por vez

				const responseData = response.data;
				//se é inserção ou alteração. Inserção só adiciona mais um registro no array
				if (id_funcionario === 0) {
					setCollaboratorData((prevState) => [...prevState, responseData]);
				} else {
					//se for update ele procura na lista aonde ta o cliente que foi selecionado e altera somente ele
					const newCollaboratorData = collaboratorData.map((item) => {
						if (item.id_funcionario === responseData.id_funcionario) {
							return responseData;
						}
						return item;
					});
					setCollaboratorData(newCollaboratorData);
				}
			} catch (error) {
				console.log(error.message);
			}
		} finally {
			reset();
			closeModalRegisterCollaborator();
		}
	};

	const errosAfterPost = (field, message) => {
		setError(field?.toLowerCase(), { type: "manual", message: message });
	};
	//#endregion

	return {
		//hook form
		errors,
		isSubmitting,
		register,
		control,
		handleSubmit,
		handleOnSubmit,
		setValue,

		//variaveis de estado
		collaboratorTypeData,
		citiesData,
		// email,

		//variaveis de estado
		loading,
		loadingCities,
		cepIsSubmitting,

		valueTab,
		hasPermission,
		podeGerenciarPermissoes,
		editandoASiMesmo,

		//context
		isOpenModalRegisterCollaborator,
		brazilStates,

		//funções
		handleSelectedState,
		handleFetchAddress,
		handleCloseModal,
		handleChangeTab,

		insertCollaboratorType,
		reloadCollaboratorTypeData,
	};
};
